import { Component, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/api/profile.service';
import { UiGuide } from 'src/app/api/ui-guide';

@Component({
  selector: 'vip-modal',
  templateUrl: './vip-modal.component.html',
  styleUrls: ['./vip-modal.component.scss']
})
export class VipModalComponent implements OnInit {
  showModal = false;

  constructor(private profileSerivce: ProfileService) { }

  ngOnInit() {
    this.getProfile();
  }

  getProfile() {
    this.profileSerivce.get().subscribe(response => {
      if (response.vip) {
        const vipGuide = response.uiGuideViewStatuses.find(item => item.guide === UiGuide.VIP_GUIDE);

        if (!vipGuide || vipGuide.viewed === false) {
          this.showModal = true;
          this.markAsShown();
        }
      }
    });
  }

  markAsShown() {
    this.profileSerivce.updateUiGuideStatus(UiGuide.VIP_GUIDE, true).subscribe();
  }
  onClose() {
    this.showModal = false;
  }
}
